<div class="companion-card">
  <div class="companion-header">
    <div>
      <h5 class="companion-title">WhatsApp Campaign Companion</h5>
      <p class="companion-sub">Create and manage campaigns from WhatsApp. Connect once with an email verification code.</p>
    </div>
  </div>

  <!-- How to connect (email OTP inside WhatsApp) -->
  <div class="connect-steps">
    <p class="steps-title">To connect a number:</p>
    <ol>
      <li>Open WhatsApp and message the LuQta bot<span *ngIf="botNumber"> ({{ botNumber }})</span>.</li>
      <li>Reply with the <strong>email of your LuQta account</strong>.</li>
      <li>Enter the <strong>6-digit code</strong> we email you. Done — your number is linked.</li>
    </ol>
    <a *ngIf="botWaLink" class="btn-wa" [href]="botWaLink" target="_blank" rel="noopener">Message the LuQta bot</a>
  </div>

  <!-- Numbers list -->
  <div class="numbers-list">
    <div class="numbers-empty" *ngIf="!loading && numbers.length === 0">
      No numbers connected yet. Follow the steps above to connect on WhatsApp.
    </div>

    <div class="number-row" *ngFor="let row of numbers">
      <div class="number-main">
        <span class="number-phone">{{ row.phone_number }}</span>
        <span class="number-badge" [ngClass]="statusClass(row)">{{ statusLabel(row) }}</span>
        <span class="number-primary" *ngIf="row.is_primary">Primary</span>
      </div>
      <div class="number-actions">
        <label class="switch" [class.disabled]="!row.is_verified">
          <input
            type="checkbox"
            [checked]="row.companion_enabled"
            [disabled]="!row.is_verified"
            (change)="toggle(row)"
          />
          <span class="slider"></span>
        </label>
        <button class="btn-remove" (click)="remove(row)" title="Unlink">Unlink</button>
      </div>
    </div>
  </div>
</div>
